export default "__VITE_PUBLIC_ASSET__89dbebc6__"